<div class="card" [class.collapse-closed]="!isCollapseOpened">
    <div class="card-header d-flex justify-content-between">
        <p class="card-title card-title-toggle flex-grow-1" (click)="toggleCollapse()">
            {{title}}
        </p>
        <span class="badge badge-pill badge-secondary-light">
            {{participantes ? participantes.length : 0 | decimalFormat:1:0:0}}
        </span>
    </div>

    <div class="collapse" #collapse>
        <div class="card-body" *ngIf="isLoading">
            <p class="text-center">
                <i class='fas fa-spinner fa-pulse'></i> {{isLoadingMessage}}
            </p>
        </div>
    
        <div class="card-body" *ngIf="isLoaded && (!participantes || participantes.length === 0)">
            <p class="text-center mb-0">
                {{emptyMessage}}
            </p>    
        </div>

        <ul class="list-group pipeline-card-list-group" *ngIf="isLoaded && participantes?.length > 0">
            <li class="list-group-item list-group-item-action" *ngFor="let participante of participantes; let first = first; let last = last" (click)="openClick(participante)"
                [ngClass]="{'first': first, 'last': last}">
                <div class="list-group-item-title">
                    {{participante.nome | clienteNome: participante.nomeFantasia:participante.codigoIntegracaoErp:participante.tipo}}    
                </div>
                <div class="list-group-item-subtitle">
                    {{participante.nome | clienteNomeSecundario: participante.nomeFantasia}}    
                </div>                                
            </li>                          
        </ul> 
    </div>
</div>